(function () {
  const DRAWER_SELECTOR = "[data-abc-cart-drawer]";
  const ITEM_SELECTOR = "[data-abc-cart-line]";
  const ADD_PRODUCT_SIMILAR_SCROLL_SELECTOR = ".abc-cart-add-product__sibling-options .m-product-option--content";
  const MODAL_MEDIA_SCROLL_SELECTOR = ".abc-cart-variant-modal__media, .abc-cart-add-product__media";
  const ADD_MORE_ANIMATION_MS = 280;
  const FREE_GIFT_HANDLE_PREFIX = "free-gift-";
  const PROMO_COPY_ICON =
    '<svg class="abc-cart-drawer__promo-copy-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" color="currentColor" aria-hidden="true" focusable="false"><path d="M8 8C8 6.11438 8 5.17157 8.58579 4.58579C9.17157 4 10.1144 4 12 4H15.5C17.3856 4 18.3284 4 18.9142 4.58579C19.5 5.17157 19.5 6.11438 19.5 8V11.5C19.5 13.3856 19.5 14.3284 18.9142 14.9142C18.3284 15.5 17.3856 15.5 15.5 15.5H12C10.1144 15.5 9.17157 15.5 8.58579 14.9142C8 14.3284 8 13.3856 8 11.5V8Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path d="M15.5 16V17C15.5 18.6569 14.1569 20 12.5 20H7C5.34315 20 4 18.6569 4 17V11.5C4 9.84315 5.34315 8.5 7 8.5H7.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>';
  const CART_SIZE_ORDER = [
    "XS",
    "(US 0-2)XS",
    "(US0-2)XS",
    "(USA0-2)XS",
    "(USAO-2)XS",
    "XS(US 0-2)",
    "XS(USA0-2)",
    "XS(USAO-2)",
    "(US 2-4)XS",
    "(US 36)XS",
    "S",
    "(US 4-6)S",
    "(US 38)S",
    "M",
    "(US 8-10)M",
    "(US 40)M",
    "L",
    "(US 12-14)L",
    "(US 14W)L",
    "(US 42)L",
    "XL",
    "(US 14-16)XL",
    "(US 16-18)XL",
    "(US 44)XL",
    "1X",
    "(US 14-16)1X",
    "(US 14W-16W)1X",
    "(US 16W)1X",
    "XXL",
    "2XL",
    "(US 18-20)XXL",
    "(US 18-20)2XL",
    "(US 18-20)2X",
    "(US 18W)2X",
    "(US 18W-20W)2X",
    "(US 20-22)",
    "(US 20-22)XXL",
    "(US20-22)XXL",
    "(US 20-22)2XL",
    "(US20-22)2XL",
    "(US 46)2XL",
    "3XL",
    "(US 22-24)XXXL",
    "(US 22-24)3XL",
    "(US 22-24)3X",
    "(US 22W-24W)3X",
    "(US 24-26)3XL",
    "(US24-26)3XL",
    "4XL",
    "(US 26-28)4XL",
    "(US 26-28)4X",
    "(US 26W-28W)4X",
    "5X",
    "(US 30-32)5X",
    "(US 30W-32W)5X",
    "2",
    "4",
    "6",
    "8",
    "10",
    "12",
    "14",
    "16",
    "18",
    "4-SHORT",
    "6-SHORT",
    "8-SHORT",
    "10-SHORT",
    "12-SHORT",
    "14-SHORT",
    "16-SHORT",
    "18-SHORT",
    "4.5(35)",
    "(US 4.5)35",
    "5.5(36)",
    "(US 5.5)36",
    "6(37)",
    "(US 6)37",
    "7(38)",
    "(US 7)38",
    "8(39)",
    "(US 8)39",
    "8.5(40)",
    "(US 8.5)40",
    "9.5(41)",
    "(US 9.5)41",
    "10(42)",
    "(US 10)42",
    "11(43)",
    "(US 11)43",
    "(US 12)44",
    "ONE SIZE",
    "S-M-L:2-2-2",
    "S-M-L-XL:1-2-2-2",
    "S-M-L-XL:1-2-2-2-1",
    "S-M-L-XL-2XL:1-2-2-2-1"
  ];
  let freeGiftDedupePromise = null;
  const CART_SIZE_ORDER_MAP = new Map(
    CART_SIZE_ORDER.map((value, index) => [normalizeCartSizeValue(value), index])
  );

  function normalizeCartSizeValue(value) {
    return String(value || "").toLowerCase().replace(/\s+/g, " ").trim();
  }

  function getCartSizeOrder(value, fallback) {
    const index = CART_SIZE_ORDER_MAP.get(normalizeCartSizeValue(value));
    return typeof index === "number" ? index : fallback + 1000;
  }

  function getDrawer() {
    return document.querySelector(DRAWER_SELECTOR);
  }

  function stripMoneyHtml(value) {
    const holder = document.createElement("div");
    holder.innerHTML = String(value || "");
    return (holder.textContent || "")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function money(cents) {
    if (typeof formatMoney === "function") {
      const settings = window.MinimogSettings || {};
      return stripMoneyHtml(formatMoney(cents, settings.money_with_currency_format || settings.money_format));
    }

    return "$" + (Number(cents || 0) / 100).toFixed(2);
  }

  function cartRoutes() {
    return (window.MinimogSettings && window.MinimogSettings.routes) || {};
  }

  function cartFetchConfig() {
    return {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    };
  }

  async function fetchCartJson() {
    const route = cartRoutes().cart || "/cart";
    const response = await fetch(`${route}.js`, {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    });
    if (!response.ok) throw new Error("Unable to load cart");
    return response.json();
  }

  async function changeCartItem(id, quantity) {
    const route = cartRoutes().cart_change_url || "/cart/change.js";
    const response = await fetch(route, {
      ...cartFetchConfig(),
      body: JSON.stringify({ id, quantity })
    });
    if (!response.ok) throw new Error("Unable to update cart");
    return response.json();
  }

  function cartItemHasFreeGiftProperty(item) {
    const properties = item && item.properties;
    if (!properties) return false;

    if (Array.isArray(properties)) {
      return properties.some((property) => property && property.name === "_free_gift" && String(property.value) === "true");
    }

    return String(properties._free_gift || "") === "true";
  }

  function isFreeGiftCartItem(item) {
    if (!item) return false;
    const handle = String(item.handle || "").toLowerCase();
    const title = String(item.product_title || item.title || "").trim().toLowerCase();
    return cartItemHasFreeGiftProperty(item) || handle.startsWith(FREE_GIFT_HANDLE_PREFIX) || title.startsWith("free gift");
  }

  async function dedupeCartFreeGifts() {
    if (freeGiftDedupePromise) return freeGiftDedupePromise;

    freeGiftDedupePromise = (async () => {
      const cart = await fetchCartJson();
      const gifts = Array.isArray(cart.items) ? cart.items.filter(isFreeGiftCartItem) : [];
      if (!gifts.length) return cart;

      let changed = false;
      const keeper = gifts[0];
      if (Number(keeper.quantity || 1) > 1 && keeper.key) {
        await changeCartItem(keeper.key, 1);
        changed = true;
      }

      for (const item of gifts.slice(1)) {
        if (!item.key) continue;
        await changeCartItem(item.key, 0);
        changed = true;
      }

      if (changed) {
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));
      }
      return changed ? fetchCartJson() : cart;
    })();

    try {
      return await freeGiftDedupePromise;
    } catch (error) {
      console.warn("Unable to normalize free gifts:", error);
      return null;
    } finally {
      freeGiftDedupePromise = null;
    }
  }

  function getPromoTiers(promo) {
    return [1, 2, 3, 4]
      .map((index) => ({
        threshold: Number(promo.getAttribute("data-tier-" + index + "-threshold") || 0),
        discount: Number(promo.getAttribute("data-tier-" + index + "-discount") || 0),
        code: promo.getAttribute("data-tier-" + index + "-code") || ""
      }))
      .filter((tier) => tier.threshold > 0 && tier.discount > 0)
      .sort((a, b) => a.threshold - b.threshold);
  }

  function appendStrong(parent, text, attrName) {
    const strong = document.createElement("strong");
    strong.textContent = text;
    if (attrName) strong.setAttribute(attrName, "");
    parent.appendChild(strong);
    return strong;
  }

  function createPromoLine(className) {
    const line = document.createElement("div");
    line.className = "abc-cart-drawer__promo-line " + className;
    return line;
  }

  function renderPromo(promo, cartTotal) {
    const content = promo.querySelector("[data-abc-promo-content]");
    if (!content) return;

    const tiers = getPromoTiers(promo);
    if (!tiers.length) return;
    promo.hidden = false;

    const active = tiers.filter((tier) => cartTotal >= tier.threshold).pop();
    const next = tiers.find((tier) => cartTotal < tier.threshold);
    const hasActiveCode = Boolean(active && active.code);

    promo.classList.toggle("is-unlocked", hasActiveCode);
    content.replaceChildren();

    if (hasActiveCode) {
      const codeLine = createPromoLine("abc-cart-drawer__promo-line--code");
      const codeText = document.createElement("span");
      codeText.append('Congrats! Use "');
      appendStrong(codeText, active.code, "data-abc-promo-code");
      codeText.append('" for ');
      appendStrong(codeText, money(active.discount));
      codeText.append(" OFF");

      const copyButton = document.createElement("button");
      copyButton.type = "button";
      copyButton.className = "abc-cart-drawer__promo-copy";
      copyButton.dataset.abcCopyDiscount = "";
      copyButton.dataset.code = active.code;
      copyButton.dataset.copyLabel = "COPY";
      copyButton.dataset.copiedLabel = "Copied";
      copyButton.dataset.copyErrorLabel = "Copy failed";
      copyButton.setAttribute("aria-label", `Copy discount code ${active.code}`);
      copyButton.textContent = "COPY";

      codeLine.append(codeText, copyButton);
      content.appendChild(codeLine);
    }

    if (next) {
      const nextLine = createPromoLine("abc-cart-drawer__promo-line--next");
      const nextText = document.createElement("span");
      nextText.append("Only ");
      appendStrong(nextText, money(Math.max(0, next.threshold - cartTotal)), "data-abc-promo-away");
      nextText.append(" away from ");
      appendStrong(nextText, money(next.discount), "data-abc-promo-next-discount");
      nextText.append(" OFF");

      const addButton = document.createElement("button");
      addButton.type = "button";
      addButton.className = "abc-cart-drawer__promo-add";
      addButton.dataset.abcOpenAddMore = "";
      addButton.textContent = "ADD";

      nextLine.append(nextText, addButton);
      content.appendChild(nextLine);
    }
  }

  function fallbackCopy(text) {
    const field = document.createElement("textarea");
    field.value = text;
    field.setAttribute("readonly", "");
    field.style.position = "fixed";
    field.style.left = "-9999px";
    document.body.appendChild(field);
    field.select();
    const copied = document.execCommand("copy");
    field.remove();
    return copied;
  }

  function showCopyFeedback(button) {
    resetCopyButton(button);
    showCopyToast(button, button.dataset.copiedLabel || "Copied to clipboard", "success");
    button.classList.remove("has-copy-error");
    button.setAttribute("aria-live", "polite");

    window.clearTimeout(button.abcCopyTimer);
    button.abcCopyTimer = window.setTimeout(() => {
      resetCopyButton(button);
    }, 1600);
  }

  function showCopyError(button) {
    resetCopyButton(button);
    showCopyToast(button, button.dataset.copyErrorLabel || "Copy failed", "error");
    button.classList.add("has-copy-error");
    button.setAttribute("aria-live", "polite");

    window.clearTimeout(button.abcCopyTimer);
    button.abcCopyTimer = window.setTimeout(() => {
      resetCopyButton(button);
      button.classList.remove("has-copy-error");
    }, 2200);
  }

  function resetCopyButton(button) {
    if (button.dataset.copyIcon === "true") {
      button.innerHTML = PROMO_COPY_ICON;
      button.setAttribute("aria-label", button.dataset.copyAriaLabel || "Copy discount code");
      return;
    }

    button.textContent = button.dataset.copyLabel || "COPY";
  }

  function showCopyToast(button, message, type) {
    const host = button.closest("[data-abc-promo-content]") || button;
    let toast = host.querySelector(".abc-cart-drawer__copy-toast");

    if (!toast) {
      toast = document.querySelector(".abc-cart-drawer__copy-toast");
    }

    if (!toast) {
      toast = document.createElement("div");
      toast.className = "abc-cart-drawer__copy-toast";
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");

      const icon = document.createElement("span");
      icon.className = "abc-cart-drawer__copy-toast-icon";
      icon.setAttribute("aria-hidden", "true");
      icon.innerHTML = '<svg viewBox="0 0 20 20" focusable="false"><circle cx="10" cy="10" r="10" fill="currentColor"/><path d="M6 10.2L8.5 12.7L14 7.3" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      const label = document.createElement("span");
      label.className = "abc-cart-drawer__copy-toast-label";

      toast.append(icon, label);
    }

    host.appendChild(toast);

    const label = toast.querySelector(".abc-cart-drawer__copy-toast-label");
    if (label) label.textContent = message;

    toast.classList.toggle("has-copy-error", type === "error");
    window.clearTimeout(toast.abcToastTimer);
    toast.classList.remove("is-visible");

    window.requestAnimationFrame(() => {
      toast.classList.add("is-visible");
    });

    toast.abcToastTimer = window.setTimeout(() => {
      toast.classList.remove("is-visible");
    }, 1800);
  }

  async function copyDiscountCode(button) {
    const code = button.dataset.code || "";
    if (!code) return;

    try {
      let copied = false;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(code);
        copied = true;
      } else {
        copied = fallbackCopy(code);
      }
      if (copied) {
        showCopyFeedback(button);
      } else {
        showCopyError(button);
      }
    } catch (error) {
      try {
        if (fallbackCopy(code)) {
          showCopyFeedback(button);
        } else {
          showCopyError(button);
        }
      } catch (fallbackError) {
        showCopyError(button);
      }
    }
  }

  function updateTotals() {
    const drawer = getDrawer();
    if (!drawer) return;

    const items = Array.from(drawer.querySelectorAll(ITEM_SELECTOR));
    const cartTotal = items.reduce((sum, item) => sum + Number(item.dataset.abcCartLinePrice || 0), 0);
    const cartQty = items.reduce((sum, item) => sum + Number(item.dataset.abcCartQuantity || 0), 0);

    drawer.querySelectorAll("[data-abc-selected-total]").forEach((node) => {
      node.textContent = money(cartTotal);
    });

    drawer.querySelectorAll("[data-abc-selected-count]").forEach((node) => {
      node.textContent = cartQty;
    });
    drawer.querySelectorAll("[data-abc-selected-count-label]").forEach((node) => {
      node.textContent = cartQty === 1 ? "item" : "items";
    });

    const promo = drawer.querySelector("[data-abc-cart-promo]");
    if (promo) renderPromo(promo, cartTotal);

    const tiers = promo ? getPromoTiers(promo) : [];
    const nextTier = tiers.find((tier) => cartTotal < tier.threshold);
    drawer.querySelectorAll("[data-abc-add-more-away]").forEach((node) => {
      node.textContent = nextTier ? money(Math.max(0, nextTier.threshold - cartTotal)) : money(0);
    });
    drawer.querySelectorAll("[data-abc-add-more-next]").forEach((node) => {
      node.textContent = nextTier ? money(nextTier.discount) : money(0);
    });

    const summary = drawer.querySelector("[data-abc-cart-summary]");
    const freeShippingAway = drawer.querySelector("[data-abc-free-shipping-away]");
    if (summary && freeShippingAway) {
      const threshold = Number(summary.dataset.freeShippingThreshold || 0);
      const away = Math.max(0, threshold - cartTotal);
      freeShippingAway.classList.toggle("is-free", away === 0);
      freeShippingAway.replaceChildren();
      const icon = document.createElement("span");
      icon.className = "abc-cart-drawer__shipping-status-icon";
      icon.setAttribute("aria-hidden", "true");
      icon.innerHTML = '<svg viewBox="0 0 24 24" focusable="false"><path d="M3 7h11v10H3z"></path><path d="M14 10h4l3 3v4h-7z"></path><path d="M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path><path d="M18 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path></svg>';
      const text = document.createElement("span");
      text.className = "abc-cart-drawer__shipping-status-text";
      if (away === 0) {
        text.textContent = "Free Standard shipping unlocked";
      } else {
        const amount = document.createElement("span");
        amount.className = "abc-cart-drawer__shipping-away-amount";
        amount.textContent = money(away);
        const strong = document.createElement("strong");
        strong.textContent = "Free Standard shipping";
        text.append("Buy ", amount, " more to enjoy ", strong);
      }
      freeShippingAway.append(icon, text);
    }

    const checkout = drawer.querySelector(".abc-cart-drawer__checkout");
    if (checkout) {
      if (!checkout.hasAttribute("data-terms-action")) checkout.disabled = cartQty === 0;
      checkout.classList.toggle("abc-cart-drawer__checkout--empty", cartQty === 0);
    }
  }

  function openCoupon(drawer) {
    const couponButton = drawer.querySelector('[data-open="coupon"]');
    if (couponButton) {
      couponButton.click();
    }
  }

  function getAddMoreGrid(drawer) {
    return drawer && drawer.querySelector("[data-abc-add-more-grid]");
  }

  function appendAddMoreProducts(grid, html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const nextMarker = doc.querySelector("[data-abc-add-more-next-page]");
    if (nextMarker) {
      grid.dataset.nextPage = nextMarker.dataset.abcAddMoreNextPage || "";
      nextMarker.remove();
    } else {
      grid.dataset.nextPage = "";
    }

    const fragment = document.createDocumentFragment();
    let appendedCount = 0;
    doc.body.querySelectorAll(".abc-cart-add-more__card, [data-abc-add-more-product-modal]").forEach((node) => {
      fragment.appendChild(node);
      appendedCount += 1;
    });
    if (appendedCount > 0) {
      grid.appendChild(fragment);
      if (window.AbcSpuOptions && typeof window.AbcSpuOptions.refresh === "function") {
        window.AbcSpuOptions.refresh(grid);
      }
    }
  }

  async function loadAddMoreProducts(drawer) {
    const grid = getAddMoreGrid(drawer);
    if (!grid || grid.dataset.loading === "true") return;

    const nextPage = Number(grid.dataset.nextPage || 0);
    if (!nextPage || !grid.dataset.collectionUrl) return;

    grid.dataset.loading = "true";
    grid.classList.add("is-loading");
    const controller = typeof AbortController === "function" ? new AbortController() : null;
    const timeoutId = window.setTimeout(() => {
      if (controller) {
        controller.abort();
      } else {
        grid.dataset.loading = "false";
        grid.classList.remove("is-loading");
      }
    }, 10000);

    try {
      const url = new URL(grid.dataset.collectionUrl, window.location.origin);
      url.searchParams.set("page", String(nextPage));
      const response = await fetch(url.toString(), {
        credentials: "same-origin",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        signal: controller ? controller.signal : undefined
      });
      if (!response.ok) throw new Error("Unable to load add more products");
      appendAddMoreProducts(grid, await response.text());
    } catch (error) {
      grid.dataset.nextPage = String(nextPage);
    } finally {
      window.clearTimeout(timeoutId);
      grid.dataset.loading = "false";
      grid.classList.remove("is-loading");
    }
  }

  function loadAddMoreProductsNearBottom(drawer) {
    const panel = drawer && drawer.querySelector("[data-abc-add-more-panel]");
    if (!panel) return;

    const distanceToBottom = panel.scrollHeight - panel.scrollTop - panel.clientHeight;
    if (distanceToBottom < 500) {
      loadAddMoreProducts(drawer);
    }
  }

  function openAddMorePanel(drawer) {
    const panel = drawer && drawer.querySelector("[data-abc-add-more]");
    if (!panel) {
      openCoupon(drawer);
      return;
    }

    const footer = drawer.querySelector(".m-cart-drawer__footer--wrapper");
    window.clearTimeout(panel._abcCloseTimer);
    panel.classList.remove("is-closing");
    drawer.classList.add("is-add-more-open");
    const footerHeight = footer ? Math.ceil(footer.getBoundingClientRect().height) : 0;
    panel.style.setProperty("--abc-add-more-footer-offset", footerHeight + "px");
    panel.classList.add("is-open");
    panel.setAttribute("aria-hidden", "false");
    if (window.AbcSpuOptions && typeof window.AbcSpuOptions.refresh === "function") {
      window.AbcSpuOptions.refresh(panel);
    }
    loadAddMoreProducts(drawer);
  }

  function closeAddMorePanel(drawer) {
    const panel = drawer && drawer.querySelector("[data-abc-add-more]");
    if (!panel) return;

    window.clearTimeout(panel._abcCloseTimer);
    if (!panel.classList.contains("is-open")) {
      panel.classList.remove("is-closing");
      panel.setAttribute("aria-hidden", "true");
      drawer.classList.remove("is-add-more-open");
      return;
    }

    panel.classList.add("is-closing");
    panel.classList.remove("is-open");
    panel.setAttribute("aria-hidden", "true");
    panel._abcCloseTimer = window.setTimeout(() => {
      panel.classList.remove("is-closing");
      drawer.classList.remove("is-add-more-open");
      panel._abcCloseTimer = null;
    }, ADD_MORE_ANIMATION_MS);
  }

  function closeAddMoreProductModal(modal) {
    if (!modal) return;

    window.clearTimeout(modal._abcCloseTimer);
    if (!modal.classList.contains("is-open")) {
      modal.classList.remove("is-closing");
      modal.setAttribute("aria-hidden", "true");
      return;
    }

    modal.classList.add("is-closing");
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    modal._abcCloseTimer = window.setTimeout(() => {
      modal.classList.remove("is-closing");
      modal._abcCloseTimer = null;
    }, ADD_MORE_ANIMATION_MS);
  }

  function closeAllAddMoreProductModals(drawer) {
    (drawer || document).querySelectorAll("[data-abc-add-more-product-modal]").forEach(closeAddMoreProductModal);
  }

  function getAddMoreVariantData(modal) {
    if (!modal) return [];
    if (modal._abcAddMoreVariantData) return modal._abcAddMoreVariantData;

    const script = modal.querySelector("[data-abc-add-more-variants]");
    try {
      modal._abcAddMoreVariantData = JSON.parse(script ? script.textContent : "[]");
    } catch (error) {
      modal._abcAddMoreVariantData = [];
    }

    return modal._abcAddMoreVariantData;
  }

  function getAddMoreSelectedOptions(modal) {
    return Array.from(modal.querySelectorAll("[data-abc-add-more-option]"))
      .sort((a, b) => Number(a.dataset.optionPosition || 0) - Number(b.dataset.optionPosition || 0))
      .map((group) => {
        const active = group.querySelector("[data-abc-add-more-option-value].is-active");
        return active ? active.dataset.optionValue : "";
      });
  }

  function findAddMoreSelectedVariant(modal) {
    const selectedOptions = getAddMoreSelectedOptions(modal);
    return getAddMoreVariantData(modal).find((variant) => {
      return selectedOptions.every((value, index) => !value || variant.options[index] === value);
    });
  }

  function updateAddMoreSizeLayout(modal) {
    if (!modal) return;

    modal.querySelectorAll(".abc-cart-add-product__option--size .abc-cart-add-product__values").forEach((values) => {
      const buttons = Array.from(values.querySelectorAll(".abc-cart-add-product__value"));
      const availableWidth = values.clientWidth;
      if (!buttons.length || !availableWidth) return;

      const style = window.getComputedStyle(values);
      const gap = parseFloat(style.columnGap || style.gap || 0) || 0;
      const requiredWidths = buttons.map(getTextWidth);
      const canFitColumns = (columns) => {
        const buttonWidth = (availableWidth - gap * (columns - 1)) / columns;
        return requiredWidths.every((requiredWidth) => requiredWidth <= buttonWidth);
      };
      const columns = canFitColumns(4) ? 4 : canFitColumns(3) ? 3 : 2;

      values.classList.toggle("abc-cart-add-size-columns-3", columns === 3);
      values.classList.toggle("abc-cart-add-size-columns-2", columns === 2);
    });
  }

  function bindSimilarStyleScroller(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    const contents = [];
    if (root.matches && root.matches(ADD_PRODUCT_SIMILAR_SCROLL_SELECTOR)) contents.push(root);
    contents.push(...root.querySelectorAll(ADD_PRODUCT_SIMILAR_SCROLL_SELECTOR));

    contents.forEach((content) => {
      if (content.dataset.abcSimilarStyleScroll === "true") return;
      if (content.dataset.abcSimilarStyleScrollBound === "true") return;
      content.dataset.abcSimilarStyleScrollBound = "true";

      const similarStyle = content.closest(".m-product-similar-style");
      const previousButton = similarStyle && similarStyle.querySelector("[data-similar-style-prev]");
      const nextButton = similarStyle && similarStyle.querySelector("[data-similar-style-next]");
      let pointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let isDragging = false;
      let suppressClick = false;
      let stateFrame = null;

      const updateState = () => {
        stateFrame = null;
        const maxScroll = Math.max(content.scrollWidth - content.clientWidth, 0);
        const scrollLeft = Math.max(content.scrollLeft, 0);
        const canScrollLeft = scrollLeft > 1;
        const canScrollRight = maxScroll - scrollLeft > 1;

        if (similarStyle) {
          similarStyle.classList.toggle("can-scroll-left", canScrollLeft);
          similarStyle.classList.toggle("can-scroll-right", canScrollRight);
          similarStyle.classList.toggle("has-overflow", maxScroll > 1);
        }
        if (previousButton) previousButton.disabled = !canScrollLeft;
        if (nextButton) nextButton.disabled = !canScrollRight;
      };

      const scheduleStateUpdate = () => {
        if (stateFrame) return;
        stateFrame = window.requestAnimationFrame(updateState);
      };

      const scrollByPage = (direction) => {
        const card = content.querySelector(".m-abc-spu-option");
        const cardWidth = card ? card.getBoundingClientRect().width : 74;
        const step = Math.max(cardWidth * 3 + 30, content.clientWidth * 0.72);
        content.scrollBy({ left: step * direction, behavior: "smooth" });
        window.setTimeout(scheduleStateUpdate, 180);
      };

      content.addEventListener(
        "wheel",
        (event) => {
          const canScroll = content.scrollWidth > content.clientWidth + 1;
          if (!canScroll || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

          content.scrollLeft += event.deltaY;
          event.preventDefault();
          scheduleStateUpdate();
        },
        { passive: false }
      );

      content.addEventListener("scroll", scheduleStateUpdate, { passive: true });
      window.addEventListener("resize", scheduleStateUpdate);

      if (previousButton) {
        previousButton.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          scrollByPage(-1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          scrollByPage(1);
        });
      }

      content.addEventListener("pointerdown", (event) => {
        if (
          (event.pointerType !== "mouse" && event.pointerType !== "touch") ||
          (event.pointerType === "mouse" && event.button !== 0) ||
          content.scrollWidth <= content.clientWidth + 1
        ) {
          return;
        }

        pointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = content.scrollLeft;
        isDragging = false;
        content.setPointerCapture(pointerId);
      });

      content.addEventListener("pointermove", (event) => {
        if (pointerId !== event.pointerId) return;

        const distance = event.clientX - startX;
        if (!isDragging && Math.abs(distance) < 4) return;

        isDragging = true;
        content.classList.add("is-dragging");
        content.scrollLeft = startScrollLeft - distance;
        scheduleStateUpdate();
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
      });

      const endDrag = (event) => {
        if (pointerId !== event.pointerId) return;

        suppressClick = isDragging;
        pointerId = null;
        isDragging = false;
        content.classList.remove("is-dragging");
      };

      content.addEventListener("pointerup", endDrag);
      content.addEventListener("pointercancel", endDrag);
      content.addEventListener(
        "click",
        (event) => {
          if (!suppressClick) return;

          suppressClick = false;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );

      window.requestAnimationFrame(updateState);
      window.setTimeout(updateState, 140);
      window.setTimeout(updateState, 420);
      window.setTimeout(updateState, 900);
    });
  }

  function updateAddMoreSimilarStyleState(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    const contents = [];
    if (root.matches && root.matches(ADD_PRODUCT_SIMILAR_SCROLL_SELECTOR)) contents.push(root);
    contents.push(...root.querySelectorAll(ADD_PRODUCT_SIMILAR_SCROLL_SELECTOR));

    contents.forEach((content) => {
      const similarStyle = content.closest(".m-product-similar-style");
      if (!similarStyle) return;

      const previousButton = similarStyle.querySelector("[data-similar-style-prev]");
      const nextButton = similarStyle.querySelector("[data-similar-style-next]");
      const maxScroll = Math.max(content.scrollWidth - content.clientWidth, 0);
      const scrollLeft = Math.max(content.scrollLeft, 0);
      const canScrollLeft = scrollLeft > 1;
      const canScrollRight = maxScroll - scrollLeft > 1;

      similarStyle.classList.toggle("can-scroll-left", canScrollLeft);
      similarStyle.classList.toggle("can-scroll-right", canScrollRight);
      similarStyle.classList.toggle("has-overflow", maxScroll > 1);
      if (previousButton) previousButton.disabled = !canScrollLeft;
      if (nextButton) nextButton.disabled = !canScrollRight;
    });
  }

  function refreshAddMoreSimilarStyleState(scope) {
    updateAddMoreSimilarStyleState(scope);
    window.requestAnimationFrame(() => updateAddMoreSimilarStyleState(scope));
    [80, 180, 320, 600, 1000].forEach((delay) => {
      window.setTimeout(() => updateAddMoreSimilarStyleState(scope), delay);
    });
  }

  function bindModalMediaScroller(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    const galleries = [];
    if (root.matches && root.matches(MODAL_MEDIA_SCROLL_SELECTOR)) galleries.push(root);
    galleries.push(...root.querySelectorAll(MODAL_MEDIA_SCROLL_SELECTOR));

    galleries.forEach((gallery) => {
      if (gallery.dataset.abcMediaScrollBound === "true") return;
      gallery.dataset.abcMediaScrollBound = "true";

      let pointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let isDragging = false;
      let stateFrame = null;

      const updateState = () => {
        stateFrame = null;
        const maxScroll = Math.max(gallery.scrollWidth - gallery.clientWidth, 0);
        const scrollLeft = Math.max(gallery.scrollLeft, 0);
        gallery.classList.toggle("has-overflow", maxScroll > 1);
        gallery.classList.toggle("can-scroll-left", scrollLeft > 1);
        gallery.classList.toggle("can-scroll-right", maxScroll - scrollLeft > 1);
      };

      const scheduleStateUpdate = () => {
        if (stateFrame) return;
        stateFrame = window.requestAnimationFrame(updateState);
      };

      gallery.addEventListener(
        "wheel",
        (event) => {
          if (gallery.scrollWidth <= gallery.clientWidth + 1 || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
          gallery.scrollLeft += event.deltaY;
          event.preventDefault();
          scheduleStateUpdate();
        },
        { passive: false }
      );

      gallery.addEventListener("scroll", scheduleStateUpdate, { passive: true });
      gallery.addEventListener("pointerdown", (event) => {
        if (
          (event.pointerType !== "mouse" && event.pointerType !== "touch") ||
          (event.pointerType === "mouse" && event.button !== 0) ||
          gallery.scrollWidth <= gallery.clientWidth + 1
        ) {
          return;
        }

        pointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = gallery.scrollLeft;
        isDragging = false;
        gallery.setPointerCapture(pointerId);
      });

      gallery.addEventListener("pointermove", (event) => {
        if (pointerId !== event.pointerId) return;

        const distance = event.clientX - startX;
        if (!isDragging && Math.abs(distance) < 4) return;

        isDragging = true;
        gallery.classList.add("is-dragging");
        gallery.scrollLeft = startScrollLeft - distance;
        scheduleStateUpdate();
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
      });

      const endDrag = (event) => {
        if (pointerId !== event.pointerId) return;
        pointerId = null;
        isDragging = false;
        gallery.classList.remove("is-dragging");
      };

      gallery.addEventListener("pointerup", endDrag);
      gallery.addEventListener("pointercancel", endDrag);
      window.addEventListener("resize", scheduleStateUpdate);
      updateState();
      window.setTimeout(updateState, 120);
    });
  }

  function refreshModalMediaScroller(scope) {
    bindModalMediaScroller(scope);
    window.requestAnimationFrame(() => bindModalMediaScroller(scope));
    [120, 320, 700].forEach((delay) => {
      window.setTimeout(() => {
        bindModalMediaScroller(scope);
        const root = scope && scope.querySelectorAll ? scope : document;
        root.querySelectorAll(MODAL_MEDIA_SCROLL_SELECTOR).forEach((gallery) => {
          gallery.dispatchEvent(new Event("scroll"));
        });
      }, delay);
    });
  }

  function refreshAddMoreSimilarStyles(modal) {
    if (window.AbcSpuOptions && typeof window.AbcSpuOptions.refresh === "function") {
      window.AbcSpuOptions.refresh(modal);
    }

    refreshModalMediaScroller(modal);
    bindSimilarStyleScroller(modal);
    refreshAddMoreSimilarStyleState(modal);
    window.requestAnimationFrame(() => bindSimilarStyleScroller(modal));
    window.setTimeout(() => bindSimilarStyleScroller(modal), 120);
    window.setTimeout(() => refreshAddMoreSimilarStyleState(modal), 120);
  }

  function sortAddMoreSizeOptions(modal) {
    if (!modal) return;

    modal.querySelectorAll(".abc-cart-add-product__option--size .abc-cart-add-product__values").forEach((values) => {
      Array.from(values.querySelectorAll("[data-abc-add-more-option-value]"))
        .map((button, index) => ({
          button,
          index,
          value: button.dataset.optionValue || button.textContent
        }))
        .sort((a, b) => getCartSizeOrder(a.value, a.index) - getCartSizeOrder(b.value, b.index))
        .forEach(({ button }) => values.appendChild(button));
    });
  }

  function updateAddMoreModalState(modal) {
    if (!modal) return;

    const variants = getAddMoreVariantData(modal);
    const selectedOptions = getAddMoreSelectedOptions(modal);

    modal.querySelectorAll("[data-abc-add-more-option]").forEach((group) => {
      const optionIndex = Number(group.dataset.optionPosition || 1) - 1;
      const active = group.querySelector("[data-abc-add-more-option-value].is-active");
      const label = group.querySelector("[data-abc-add-more-option-selected]");
      if (active && label) label.textContent = active.dataset.optionValue || "";

      group.querySelectorAll("[data-abc-add-more-option-value]").forEach((button) => {
        const testOptions = selectedOptions.slice();
        testOptions[optionIndex] = button.dataset.optionValue;
        const isAvailable = variants.some((variant) => {
          return variant.available && testOptions.every((value, index) => !value || variant.options[index] === value);
        });

        button.classList.toggle("is-unavailable", !isAvailable);
        button.setAttribute("aria-disabled", isAvailable ? "false" : "true");
      });
    });

    const selectedVariant = findAddMoreSelectedVariant(modal);
    const price = modal.querySelector("[data-abc-add-more-price]");
    const submit = modal.querySelector("[data-abc-add-more-submit]");
    const message = modal.querySelector("[data-abc-add-more-message]");

    if (price && selectedVariant) price.textContent = money(selectedVariant.price);
    if (submit) {
      submit.dataset.selectedVariant = selectedVariant ? selectedVariant.id : "";
      submit.disabled = !selectedVariant || !selectedVariant.available;
    }
    if (message) {
      message.hidden = Boolean(selectedVariant && selectedVariant.available);
      message.textContent = "This option is currently unavailable.";
    }
  }

  function openAddMoreProductModal(trigger) {
    const drawer = getDrawer();
    const modal = drawer && document.getElementById(trigger.dataset.modalId || "");
    if (!modal) return;

    closeAllAddMoreProductModals(drawer);
    const drawerInner = drawer.querySelector(".m-cart-drawer__inner");
    if (drawerInner && modal.parentElement !== drawerInner) {
      drawerInner.appendChild(modal);
    }
    window.clearTimeout(modal._abcCloseTimer);
    modal.classList.remove("is-closing");
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    refreshAddMoreSimilarStyles(modal);
    sortAddMoreSizeOptions(modal);
    updateAddMoreModalState(modal);
    window.requestAnimationFrame(() => updateAddMoreSizeLayout(modal));

    const closeButton = modal.querySelector("[data-abc-add-more-product-close]");
    if (closeButton) closeButton.focus({ preventScroll: true });
  }

  async function addMoreVariantToCart({ variantId, control }) {
    if (!variantId) return;

    const drawer = getDrawer();
    const loadingTarget = drawer && drawer.querySelector(".m-cart-drawer__inner");
    const loading = window.MinimogLibs && loadingTarget ? new MinimogLibs.AnimateLoading(loadingTarget, { overlay: loadingTarget }) : null;
    const routes = window.MinimogSettings && window.MinimogSettings.routes;
    if (!routes) return;

    if (control) control.disabled = true;
    if (loading) loading.start();

    try {
      await fetch(routes.cart_add_url, {
        ...fetchConfig(),
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      }).then((response) => response.json());

      closeAllAddMoreProductModals(drawer);
      closeAddMorePanel(drawer);
      document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));
    } catch (error) {
      console.error("Failed to add recommended product:", error);
      if (control) control.disabled = false;
    } finally {
      if (loading) loading.finish();
    }
  }

  function syncWishlistState() {
    const wishlist = window.MinimogTheme && window.MinimogTheme.Wishlist;
    if (!wishlist || typeof wishlist.setWishlistButtonsState !== "function") return;

    wishlist.setWishlistButtonsState();
    if (typeof wishlist.updateWishlistCount === "function") {
      wishlist.updateWishlistCount();
    }
  }

  function closeVariantModal(modal) {
    if (!modal) return;

    window.clearTimeout(modal._abcCloseTimer);
    if (!modal.classList.contains("is-open")) {
      modal.classList.remove("is-closing");
      modal.setAttribute("aria-hidden", "true");
      return;
    }

    modal.classList.add("is-closing");
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    modal._abcCloseTimer = window.setTimeout(() => {
      modal.classList.remove("is-closing");
      modal._abcCloseTimer = null;
    }, ADD_MORE_ANIMATION_MS);
  }

  function closeAllVariantModals(drawer) {
    (drawer || document).querySelectorAll("[data-abc-cart-variant-modal]").forEach(closeVariantModal);
  }

  function getVariantData(modal) {
    if (!modal) return [];
    if (modal._abcVariantData) return modal._abcVariantData;

    const script = modal.querySelector("[data-abc-cart-variant-json]");
    try {
      modal._abcVariantData = JSON.parse(script ? script.textContent : "[]");
    } catch (error) {
      modal._abcVariantData = [];
    }

    return modal._abcVariantData;
  }

  function getSelectedOptions(modal) {
    return Array.from(modal.querySelectorAll("[data-abc-cart-option]"))
      .sort((a, b) => Number(a.dataset.optionPosition || 0) - Number(b.dataset.optionPosition || 0))
      .map((group) => {
        const active = group.querySelector("[data-abc-cart-option-value].is-active");
        return active ? active.dataset.optionValue : "";
      });
  }

  function findSelectedVariant(modal) {
    const selectedOptions = getSelectedOptions(modal);
    return getVariantData(modal).find((variant) => {
      return selectedOptions.every((value, index) => !value || variant.options[index] === value);
    });
  }

  function updateOptionAvailability(modal) {
    const variants = getVariantData(modal);
    const selectedOptions = getSelectedOptions(modal);

    modal.querySelectorAll("[data-abc-cart-option]").forEach((group) => {
      const optionIndex = Number(group.dataset.optionPosition || 1) - 1;

      group.querySelectorAll("[data-abc-cart-option-value]").forEach((button) => {
        const testOptions = selectedOptions.slice();
        testOptions[optionIndex] = button.dataset.optionValue;
        const isAvailable = variants.some((variant) => {
          return variant.available && testOptions.every((value, index) => !value || variant.options[index] === value);
        });

        button.classList.toggle("is-unavailable", !isAvailable);
        button.setAttribute("aria-disabled", isAvailable ? "false" : "true");
      });
    });
  }

  function getTextWidth(button) {
    const style = window.getComputedStyle(button);
    const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
    const context = canvas.getContext("2d");
    if (!context) return 0;

    context.font = [style.fontStyle, style.fontWeight, style.fontSize, style.fontFamily].join(" ");

    return (
      context.measureText((button.textContent || "").trim()).width +
      parseFloat(style.paddingLeft || 0) +
      parseFloat(style.paddingRight || 0) +
      parseFloat(style.borderLeftWidth || 0) +
      parseFloat(style.borderRightWidth || 0) +
      2
    );
  }

  function updateSizeOptionLayout(modal) {
    if (!modal) return;

    modal.querySelectorAll(".abc-cart-variant-modal__option--size .abc-cart-variant-modal__values").forEach((values) => {
      const buttons = Array.from(values.querySelectorAll(".abc-cart-variant-modal__value"));
      const availableWidth = values.clientWidth;
      if (!buttons.length || !availableWidth) return;

      const style = window.getComputedStyle(values);
      const gap = parseFloat(style.columnGap || style.gap || 0) || 0;
      const requiredWidths = buttons.map(getTextWidth);
      const canFitColumns = (columns) => {
        const buttonWidth = (availableWidth - gap * (columns - 1)) / columns;
        return requiredWidths.every((requiredWidth) => requiredWidth <= buttonWidth);
      };
      const columns = canFitColumns(4) ? 4 : canFitColumns(3) ? 3 : 2;

      values.classList.toggle("abc-cart-size-columns-3", columns === 3);
      values.classList.toggle("abc-cart-size-columns-2", columns === 2);
    });
  }

  function sortSizeOptionValues(modal) {
    if (!modal) return;

    modal.querySelectorAll(".abc-cart-variant-modal__option--size .abc-cart-variant-modal__values").forEach((values) => {
      Array.from(values.querySelectorAll("[data-abc-cart-option-value]"))
        .map((button, index) => ({
          button,
          index,
          value: button.dataset.optionValue || button.textContent
        }))
        .sort((a, b) => getCartSizeOrder(a.value, a.index) - getCartSizeOrder(b.value, b.index))
        .forEach(({ button }) => values.appendChild(button));
    });
  }

  function updateVariantModalState(modal) {
    if (!modal) return;

    modal.querySelectorAll("[data-abc-cart-option]").forEach((group) => {
      const active = group.querySelector("[data-abc-cart-option-value].is-active");
      const label = group.querySelector("[data-abc-cart-option-selected]");
      if (active && label) label.textContent = active.dataset.optionValue || "";
    });

    updateOptionAvailability(modal);

    const selectedVariant = findSelectedVariant(modal);
    const updateButton = modal.querySelector("[data-abc-cart-variant-update]");
    const message = modal.querySelector("[data-abc-cart-variant-message]");
    const price = modal.querySelector("[data-abc-cart-variant-price]");

    if (price && selectedVariant) price.textContent = money(selectedVariant.price);
    if (updateButton) {
      updateButton.dataset.selectedVariant = selectedVariant ? selectedVariant.id : "";
      updateButton.disabled = !selectedVariant || !selectedVariant.available;
    }
    if (message) {
      message.hidden = Boolean(selectedVariant && selectedVariant.available);
      message.textContent = "This option is currently unavailable.";
    }
  }

  function openVariantModal(trigger) {
    const drawer = getDrawer();
    const modal = drawer && document.getElementById(trigger.dataset.modalId || "");
    if (!modal) return;

    closeAllVariantModals(drawer);
    window.clearTimeout(modal._abcCloseTimer);
    modal.classList.remove("is-closing");
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    refreshModalMediaScroller(modal);
    sortSizeOptionValues(modal);
    updateVariantModalState(modal);
    window.requestAnimationFrame(() => updateSizeOptionLayout(modal));

    const closeButton = modal.querySelector("[data-abc-cart-variant-close]");
    if (closeButton) closeButton.focus({ preventScroll: true });
  }

  async function replaceVariant({ selectedVariant, currentVariant, line, quantity, control, modal }) {
    if (!selectedVariant || selectedVariant === currentVariant) return;

    const drawer = getDrawer();
    const cartItems = control && control.closest("m-cart-items");
    const loadingTarget = drawer && drawer.querySelector(".m-cart-drawer__inner");
    const loading = window.MinimogLibs && loadingTarget ? new MinimogLibs.AnimateLoading(loadingTarget, { overlay: loadingTarget }) : null;

    const routes = window.MinimogSettings && window.MinimogSettings.routes;
    if (!line || !routes) return;

    if (control) control.disabled = true;
    if (loading) loading.start();

    try {
      await fetch(routes.cart_change_url, {
        ...fetchConfig(),
        body: JSON.stringify({ line, quantity: 0 })
      }).then((response) => response.json());

      await fetch(routes.cart_add_url, {
        ...fetchConfig(),
        body: JSON.stringify({ items: [{ id: Number(selectedVariant), quantity }] })
      }).then((response) => response.json());

      closeVariantModal(modal);
      document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));
    } catch (error) {
      console.error("Failed to replace cart variant:", error);
      if (cartItems && window.MinimogTheme && MinimogTheme.Notification) {
        MinimogTheme.Notification.show({
          target: cartItems,
          type: "warning",
          message: "Unable to update this item. Please try again."
        });
      }
      if (control) control.disabled = false;
    } finally {
      if (loading) loading.finish();
    }
  }

  function decreaseCartLine(button) {
    const line = Number(button.dataset.line || 0);
    const quantity = Number(button.dataset.quantity || 0);
    const cartItems = button.closest("m-cart-items");
    if (!line || quantity <= 1 || !cartItems || typeof cartItems.updateQuantity !== "function") return;

    button.disabled = true;
    cartItems.updateQuantity(line, quantity - 1);
  }

  function bind(drawer) {
    if (!drawer || drawer.dataset.abcCartEnhanced === "true") {
      updateTotals();
      syncWishlistState();
      return;
    }

    drawer.dataset.abcCartEnhanced = "true";
    const addMorePanel = drawer.querySelector("[data-abc-add-more-panel]");
    if (addMorePanel) {
      addMorePanel.addEventListener("scroll", () => loadAddMoreProductsNearBottom(drawer), { passive: true });
    }

    drawer.addEventListener("change", (event) => {
      const target = event.target;

      if (target.matches("[data-abc-cart-variant-select]")) {
        replaceVariant({
          selectedVariant: target.value,
          currentVariant: target.dataset.currentVariant,
          line: Number(target.dataset.line || 0),
          quantity: Number(target.dataset.quantity || 1),
          control: target
        });
      }
    });

    drawer.addEventListener("click", (event) => {
      const decreaseButton = event.target.closest("[data-abc-cart-decrease]");
      if (decreaseButton) {
        event.preventDefault();
        event.stopPropagation();
        decreaseCartLine(decreaseButton);
        return;
      }

      const variantTrigger = event.target.closest("[data-abc-cart-variant-trigger]");
      if (variantTrigger) {
        event.preventDefault();
        openVariantModal(variantTrigger);
        return;
      }

      const closeTrigger = event.target.closest("[data-abc-cart-variant-close]");
      if (closeTrigger) {
        event.preventDefault();
        closeVariantModal(closeTrigger.closest("[data-abc-cart-variant-modal]"));
        return;
      }

      const optionButton = event.target.closest("[data-abc-cart-option-value]");
      if (optionButton) {
        event.preventDefault();
        if (optionButton.classList.contains("is-unavailable")) return;

        const group = optionButton.closest("[data-abc-cart-option]");
        if (group) {
          group.querySelectorAll("[data-abc-cart-option-value]").forEach((button) => {
            button.classList.remove("is-active");
            button.setAttribute("aria-pressed", "false");
          });
        }
        optionButton.classList.add("is-active");
        optionButton.setAttribute("aria-pressed", "true");
        updateVariantModalState(optionButton.closest("[data-abc-cart-variant-modal]"));
        return;
      }

      const updateButton = event.target.closest("[data-abc-cart-variant-update]");
      if (updateButton) {
        event.preventDefault();
        replaceVariant({
          selectedVariant: updateButton.dataset.selectedVariant,
          currentVariant: updateButton.dataset.currentVariant,
          line: Number(updateButton.dataset.line || 0),
          quantity: Number(updateButton.dataset.quantity || 1),
          control: updateButton,
          modal: updateButton.closest("[data-abc-cart-variant-modal]")
        });
        return;
      }

      const addMoreTrigger = event.target.closest("[data-abc-open-add-more], [data-abc-open-coupon]");
      if (addMoreTrigger) {
        event.preventDefault();
        event.stopPropagation();
        openAddMorePanel(drawer);
        return;
      }

      const addMoreClose = event.target.closest("[data-abc-add-more-close]");
      if (addMoreClose) {
        event.preventDefault();
        event.stopPropagation();
        closeAddMorePanel(drawer);
        return;
      }

      const addMoreProductTrigger = event.target.closest("[data-abc-add-more-product-trigger]");
      if (addMoreProductTrigger) {
        event.preventDefault();
        event.stopPropagation();
        openAddMoreProductModal(addMoreProductTrigger);
        return;
      }

      const addMoreProductClose = event.target.closest("[data-abc-add-more-product-close]");
      if (addMoreProductClose) {
        event.preventDefault();
        event.stopPropagation();
        closeAddMoreProductModal(addMoreProductClose.closest("[data-abc-add-more-product-modal]"));
        return;
      }

      const addMoreOptionButton = event.target.closest("[data-abc-add-more-option-value]");
      if (addMoreOptionButton) {
        event.preventDefault();
        event.stopPropagation();
        if (addMoreOptionButton.classList.contains("is-unavailable")) return;

        const group = addMoreOptionButton.closest("[data-abc-add-more-option]");
        if (group) {
          group.querySelectorAll("[data-abc-add-more-option-value]").forEach((button) => {
            button.classList.remove("is-active");
            button.setAttribute("aria-pressed", "false");
          });
        }
        addMoreOptionButton.classList.add("is-active");
        addMoreOptionButton.setAttribute("aria-pressed", "true");
        updateAddMoreModalState(addMoreOptionButton.closest("[data-abc-add-more-product-modal]"));
        return;
      }

      const addMoreSubmit = event.target.closest("[data-abc-add-more-submit]");
      if (addMoreSubmit) {
        event.preventDefault();
        event.stopPropagation();
        addMoreVariantToCart({
          variantId: addMoreSubmit.dataset.selectedVariant,
          control: addMoreSubmit
        });
        return;
      }

      const addMoreDirect = event.target.closest("[data-abc-add-more-direct]");
      if (addMoreDirect) {
        event.preventDefault();
        event.stopPropagation();
        addMoreVariantToCart({
          variantId: addMoreDirect.dataset.variantId,
          control: addMoreDirect
        });
        return;
      }

      const copyTrigger = event.target.closest("[data-abc-copy-discount]");
      if (copyTrigger) {
        event.preventDefault();
        copyDiscountCode(copyTrigger);
        return;
      }
    });

    updateTotals();
    syncWishlistState();
    bindSimilarStyleScroller(drawer);
    bindModalMediaScroller(drawer);
  }

  function boot() {
    bind(getDrawer());
    dedupeCartFreeGifts();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("cart:updated", () => window.setTimeout(boot, 0));
  document.addEventListener("cart:refresh", () => window.setTimeout(boot, 400));
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const drawer = getDrawer();
    closeAllVariantModals(drawer);
    closeAllAddMoreProductModals(drawer);
    closeAddMorePanel(drawer);
  });
  window.addEventListener("resize", () => {
    const drawer = getDrawer();
    if (!drawer) return;

    const modal = drawer.querySelector("[data-abc-cart-variant-modal].is-open");
    if (modal) window.requestAnimationFrame(() => updateSizeOptionLayout(modal));
    const addMoreModal = drawer.querySelector("[data-abc-add-more-product-modal].is-open");
    if (addMoreModal) window.requestAnimationFrame(() => updateAddMoreSizeLayout(addMoreModal));
    const addMorePanel = drawer.querySelector("[data-abc-add-more].is-open");
    if (addMorePanel) openAddMorePanel(drawer);
  });
})();
